// extracted by mini-css-extract-plugin
export default {"download-page":"DownloadPage_download-page__aVtFD","input":"DownloadPage_input__-Y+OE","checkboxInput":"DownloadPage_checkboxInput__xKefE"};